// Skin Guide
document.addEventListener('click', e => {
    const isSkinBtn = e.target.hasAttribute('data-skin-control');
  
    if (isSkinBtn) {
      let skinAgeTypes = [];
      
      if(document.querySelector('.skin-guide').dataset.ageTypes){
        skinAgeTypes = JSON.parse(document.querySelector('.skin-guide').dataset.ageTypes)?.filter(e => e.length); // filter empty strings.
      }
  
      const skinTypes = JSON.parse(document.querySelector('.skin-guide').dataset.skinTypes);
      const skinTypeIndex = parseInt(e.target.dataset.skinTypeIndex);
      const skinTypeEls = document.querySelectorAll(`[data-skin-type-index="${skinTypeIndex}"]`);
      const activeEls = document.querySelectorAll('.skin-guide .active');
      const skinNavPrev = document.querySelector('.skin-guide__nav-arrow-prev');
      const skinNavNext = document.querySelector('.skin-guide__nav-arrow-next');
      const skinTypeIndexPrev = skinTypeIndex === 0 ? skinTypes.length - 1 : skinTypeIndex - 1;
      const skinTypeIndexNext = skinTypeIndex === skinTypes.length - 1 ? 0 : skinTypeIndex + 1;
  
      activeEls.forEach(el => el.classList.remove('active'));
      skinTypeEls.forEach(el => el.classList.add('active'));
      skinNavPrev.dataset.skinTypeIndex = skinTypeIndexPrev;
      skinNavNext.dataset.skinTypeIndex = skinTypeIndexNext;
      
      skinNavPrev.querySelector('.skin-guide__nav-arrow-text').textContent = skinAgeTypes.length ? skinAgeTypes[skinTypeIndexPrev].replace(/_/g, ' ') : skinTypes[skinTypeIndexPrev].replace(/_/g, ' ');
      skinNavNext.querySelector('.skin-guide__nav-arrow-text').textContent = skinAgeTypes.length ? skinAgeTypes[skinTypeIndexNext].replace(/_/g, ' ') : skinTypes[skinTypeIndexNext].replace(/_/g, ' ');
  
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });
  